import { observable, computed } from 'mobx';
import { activeTab } from './Navigation';

export class NavigationStore {
    public static instance: NavigationStore;
    @observable private _active: string;

    @computed
    public get active() {
        return this._active;
    }

    public static getInstance() {
        if (this.instance == undefined) {
            NavigationStore.instance = new NavigationStore();
        }

        return NavigationStore.instance;
    }

    public setActive(active: activeTab) {
        // console.log('set navigation active', active);
        this._active = active;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Navigation/NavigationStore.ts